var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGooglecalender = function SvgGooglecalender(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.737 4.263H4.263v9.474h9.474V4.263Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M13.737 18 18 13.737h-4.263V18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M18 4.263h-4.263v9.474H18V4.263Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M13.737 13.737H4.263V18h9.474v-4.263Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#188038",
    d: "M0 13.737v2.842A1.42 1.42 0 0 0 1.421 18h2.842v-4.263H0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1967D2",
    d: "M18 4.263V1.421A1.42 1.42 0 0 0 16.579 0h-2.842v4.263H18Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M13.737 0H1.42A1.42 1.42 0 0 0 0 1.421v12.316h4.263V4.263h9.474V0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M6.207 11.612c-.354-.239-.6-.588-.733-1.05l.821-.339c.075.284.205.505.391.661.185.156.41.233.673.233.269 0 .5-.081.693-.245a.783.783 0 0 0 .29-.624.774.774 0 0 0-.306-.632c-.203-.164-.46-.245-.765-.245h-.475v-.814h.427c.263 0 .484-.07.664-.213a.703.703 0 0 0 .27-.584c0-.22-.08-.395-.242-.527a.936.936 0 0 0-.612-.198c-.241 0-.433.064-.575.193-.142.13-.25.293-.31.475l-.814-.338c.108-.306.305-.576.596-.81.29-.232.66-.35 1.11-.35.333 0 .633.064.898.193.265.13.474.308.624.536.15.228.225.484.225.768 0 .29-.07.535-.21.737-.14.201-.311.355-.515.463v.048c.263.109.492.287.661.515.172.231.258.507.258.83 0 .321-.081.61-.245.861-.163.253-.39.452-.676.596a2.132 2.132 0 0 1-.97.218c-.416.001-.8-.118-1.153-.358Zm5.048-4.078-.902.652-.452-.684 1.62-1.168h.62v5.508h-.886V7.534Z"
  })));
};
export default SvgGooglecalender;